import type { IDateUTC } from './models';

interface IOptions {
    /** Переводит время в Московское из UTC+0, НЕ ПЕРЕДАВАТЬ ВРЕМЯ С ЧАСОВЫМ ПОЯСОМ */
    convertToMoscowDate?: boolean;
}

// Разница между Московским временем и UTC+0 временем
const MOSCOW_TIMEZONE_HOURS_OFFSET = 3;

/** Получает объект даты с UTC-параметрами */
export const getUTCDateTime = (dateStr: string, options?: IOptions): IDateUTC => {
    const date = new Date(dateStr);

    if (options?.convertToMoscowDate) {
        date.setUTCHours(date.getUTCHours() + MOSCOW_TIMEZONE_HOURS_OFFSET);
    }

    const utcYear = date.getUTCFullYear();
    const utcYearShort = utcYear.toString().slice(-2);
    const utcMonth = date.getUTCMonth();
    const utcMonthFull = `0${utcMonth + 1}`.slice(-2);
    const utcWeekDay = date.getUTCDay();
    const utcDate = date.getUTCDate();
    const utcDateFull = `0${utcDate}`.slice(-2);
    const utcHour = date.getUTCHours();
    const utcHourFull = `0${utcHour}`.slice(-2);
    const utcMinutes = date.getUTCMinutes();
    const utcMinutesFull = `0${utcMinutes}`.slice(-2);
    const utcSeconds = date.getUTCSeconds();

    return {
        utcYear,
        utcYearShort,
        utcMonth,
        utcMonthFull,
        utcDate,
        utcDateFull,
        utcHour,
        utcHourFull,
        utcMinutes,
        utcMinutesFull,
        utcSeconds,
        utcWeekDay,
    };
};
